export const mailTemplateType = {
    RegistrationAdmin: 1,
    RegistrationUser: 2,
};
